import { Store } from "redux";
import { reportError } from "../../components/ticketing/basket-v2/errorReporting";
import { EventEmitter } from "../../utils";

export function observeStore(store: Store, select: (store: Store) => unknown, onChange) {
  let currentState;

  function handleChange() {
    let nextState = select(store.getState());
    if (nextState !== currentState) {
      currentState = nextState;
      onChange(currentState);
    }
  }

  let unsubscribe = store.subscribe(handleChange);
  handleChange();
  return unsubscribe;
}

export function formatGiftCardVoucherCode(string: string, maxLength = 16) {
  let cleaned = string.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

  cleaned = cleaned.slice(0, maxLength);

  const chunks = cleaned.match(/.{1,4}/g);
  return chunks ? chunks.join("-") : "";
}

export function removeSpaces(string: string) {
  return string.replace(/\s+/g, "");
}

export async function evaluateResponse(response: Response, element: HTMLElement, defaultMesage: string, eventName: string) {  
  if (!response.ok) {
    reportError(response.status, defaultMesage);
    EventEmitter.emit(eventName);
    return null;
  }

  const responseData = await response.json();

  if (responseData?.status !== 200) {
    reportError(responseData.status, responseData?.content ?? defaultMesage);
    element.classList.add("is-invalid");
    EventEmitter.emit(eventName);    
  }

  return responseData;
}
